export default __webpack_public_path__ + "static/blog-1-shape-1-459cdb0e4199dca9a4af522508e94d4a.png";